import { ActionTypes } from 'modules/jobManager/ducks/actionTypes';
import { JOBS_TABLE_COLUMNS, JobTableData, JobTableFilterState } from 'modules/jobManager/types';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

export const fetchJobTableDataRequest = () => ({
  type: ActionTypes.FETCH_TABLE_DATA_REQUEST,
});

export const fetchJobTableDataResponse = (payload: JobTableData) => ({
  type: ActionTypes.FETCH_TABLE_DATA_RESPONSE,
  payload,
});

export const fetchJobTableDataError = () => ({
  type: ActionTypes.FETCH_TABLE_DATA_ERROR,
});

export const setJobFilterState = (payload: Partial<JobTableFilterState>) => ({
  type: ActionTypes.SET_TABLE_FILTER,
  payload,
});

export const clearJobFilterState = () => ({
  type: ActionTypes.CLEAR_TABLE_FILTER,
});

export const setJobTablePage = (payload: number) => ({
  type: ActionTypes.SET_TABLE_PAGE,
  payload,
});

export const setJobTablePageSize = (payload: number) => ({
  type: ActionTypes.SET_TABLE_PAGE_SIZE,
  payload,
});

export const setJobTableSearch = (payload: string) => ({
  type: ActionTypes.SET_TABLE_SEARCH,
  payload,
});

export const setJobTableSortBy = (payload: JOBS_TABLE_COLUMNS) => ({
  type: ActionTypes.SET_TABLE_SORT_BY,
  payload,
});

export const setJobTableSortDirection = (payload: SORT_DIRECTIONS) => ({
  type: ActionTypes.SET_TABLE_SORT_DIRECTION,
  payload,
});

export const setCreationTakeoverState = (payload: boolean) => ({
  type: ActionTypes.SET_TAKEOVER_STATE,
  payload,
});
